import React, { lazy, Suspense } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "./input.css";
import { Toaster } from "@/components/ui/toaster";
import RequireFeature from "./components/RequireFeature";
import RequireMemberSession from "./components/RequireMemberSession";

const AgentLogin = lazy(() => import("./pages/agent-login"));
const AdministratorSetup = lazy(() => import('./pages/administrator-setup'));
const PasswordReset = lazy(() => import('./pages/password-reset'));
const AgentHome = lazy(() => import("./pages/agent-home"));
const AgentTeam = lazy(() => import("./pages/agent-team"));
const AgentContacts = lazy(() => import("./pages/agent-contacts"));
const AgentCallLog = lazy(() => import("./pages/agent-call-log"));
const AgentSupervisor = lazy(() => import("./pages/agent-supervisor"));
const AgentSettings = lazy(() => import("./pages/agent-settings"));
const Chat = lazy(() => import("./pages/chat"));
const Voicemail = lazy(() => import("./pages/voicemail"));
const AdminTeam = lazy(() => import("./pages/admin-team"));
const AdminMemberEdit = lazy(() => import("./pages/admin-member-edit"));
const AdminCallRouting = lazy(() => import("./pages/admin-call-routing"));
const AdminTrunkNew = lazy(() => import("./pages/admin-trunk-new"));
const AdminTrunkEdit = lazy(() => import("./pages/admin-trunk-edit"));
const AdminCallFlows = lazy(() => import("./pages/admin-call-flows"));
const AdminFlowDesigner = lazy(() => import("./pages/admin-flow-designer"));
const AdminReports = lazy(() => import("./pages/admin-reports"));
const AdminDevices = lazy(() => import('./pages/admin-devices'));
const AdminSettings = lazy(() => import("./pages/admin-settings"));
const AdminBranding = lazy(() => import("./pages/admin-branding"));

function TenantPortal() {
  return (
    <>
      <Suspense fallback={<div className="flex min-h-screen items-center justify-center text-sm text-muted-foreground">Loading…</div>}>
      <Routes>
        <Route path="/agent/login" element={<AgentLogin />} />
        <Route path="/agent/setup" element={<AdministratorSetup />} />
        <Route path="/agent/forgot-password" element={<PasswordReset />} />
        <Route path="/agent/reset-password" element={<PasswordReset complete />} />
        <Route element={<RequireMemberSession key="agent" />}>
        <Route path="/agent" element={<AgentHome />} />
        <Route path="/agent/team" element={<AgentTeam />} />
        <Route path="/agent/contacts" element={<AgentContacts />} />
        <Route path="/agent/chat" element={<Chat />} />
        <Route path="/agent/voicemail" element={<Voicemail />} />
        <Route path="/agent/call-log" element={<AgentCallLog />} />
        <Route path="/agent/supervisor" element={<AgentSupervisor />} />
        <Route path="/agent/settings" element={<AgentSettings />} />
        </Route>
        <Route element={<RequireMemberSession key="admin" admin />}>
        <Route path="/admin/team" element={<AdminTeam />} />
        <Route path="/admin/team/:extensionId" element={<AdminMemberEdit />} />
        <Route path="/admin/routing" element={<AdminCallRouting />} />
        <Route path="/admin/routing/trunks/new" element={<AdminTrunkNew />} />
        <Route path="/admin/routing/trunks/:trunkId" element={<AdminTrunkEdit />} />
        <Route path="/admin/flows" element={<RequireFeature feature="call_flows"><AdminCallFlows /></RequireFeature>} />
        <Route path="/admin/flows/:flowId" element={<RequireFeature feature="call_flows"><AdminFlowDesigner /></RequireFeature>} />
        <Route path="/admin/reports" element={<AdminReports />} />
        <Route path="/admin/devices" element={<AdminDevices />} />
        <Route path="/admin/settings" element={<AdminSettings />} />
        <Route path="/admin/branding" element={<AdminBranding />} />
        </Route>
        <Route path="*" element={<Navigate to="/agent" replace />} />
      </Routes>
      </Suspense>
      <Toaster />
    </>
  );
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <TenantPortal />
    </BrowserRouter>
  </React.StrictMode>
);
